import { tcConfigUserEventCollectorUrl } from "./globalConfig";
import { userIsEligibleToTrack } from "./gdprConsentStatus";
import { userIsWebCrawler } from "@theconversation/shared-components/tcEventsCollector";
const eventQueue = [];
// Dispatch the event to our event collector.
// This function tries to avoid any exceptions bubbling up.
// If the analytics event can't be sent, just log and then let it be discarded.
export function dispatchEvent(event) {
    if (userIsWebCrawler())
        return;
    eventQueue.push(event);
    if (userIsEligibleToTrack())
        postQueuedEventsToCollector();
}
export function postQueuedEventsToCollector() {
    while (eventQueue.length > 0) {
        const event = eventQueue.shift();
        if (event != undefined)
            postEventToCollector(event);
    }
}
function postEventToCollector(event) {
    try {
        const eventUrl = tcConfigUserEventCollectorUrl() + "/v1/event";
        if (isNotOnProduction()) {
            console.log("Dispatching user analytics event, type: " + event.eventType);
        }
        fetch(eventUrl, {
            method: "POST",
            keepalive: true, // Requests that the request is still sent even if user navigates away. (eg. promo engagement)
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(event),
        })
            .catch((err) => {
            console.warn("Failed to dispatch event: " + err);
        })
            .then((response) => {
            if (response && response.status != 202) {
                console.warn(`Unusual status from event collector: ${response.status}`);
            }
        });
    }
    catch (err) {
        console.warn("Failed to dispatch event: " + err);
    }
}
// Checks if the environment appears to be something other than production
function isNotOnProduction() {
    const url = tcConfigUserEventCollectorUrl();
    return !url.startsWith("https://collector.theconversation.com");
}
